import * as Sentry from '@sentry/react';

export const captureMessage = Sentry.captureMessage;
